<div [formGroup]="settingsForm">
<!-- TEMPLATE ROW -->
<div class="template-row">

  <mat-form-field appearance="outline" class="template-field">
    <mat-label>Service Template</mat-label>
    <mat-select formControlName="template" class="text-field-padding"
                name="template"
                (selectionChange)="applyTemplate($event.value)">
      <mat-option [value]="null">Custom</mat-option>
      <mat-option *ngFor="let template of serviceTemplates"
                  [value]="template.key">
        {{ template.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- REQUEST ROW -->
<div class="request-main-row">
  <mat-form-field appearance="outline" class="url-field">
    <mat-label>URL</mat-label>
    <input matInput class="text-field-padding"
           placeholder="https://api.example.com/users"
           formControlName="url"
           name="url"/>
  </mat-form-field>

  <mat-form-field appearance="outline" class="method-field">
    <mat-label>Method</mat-label>
    <mat-select formControlName="httpMethod" class="text-field-padding"
                name="httpMethod">
      <mat-option value="GET">GET</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- CONFIG SECTION -->
<div class="config-grid">

  <!-- HEADERS -->
  <mat-card class="config-section">
    <mat-card-title>Headers</mat-card-title>
    <div class="table-header-4-cols">
      <div>Header</div>
      <div>Value</div>
      <div></div>
      <div></div>
    </div>

    <div class="table-row-4-cols"
         *ngFor="let header of settings.headers; let i = index">

      <!-- HEADER NAME -->
      <mat-form-field appearance="outline">
        <input matInput class="text-field-padding"
               placeholder="Authorization"
               formControlName="header_key_{{header.id}}"
               name="header_key_{{header.id}}" />
      </mat-form-field>

      <!-- HEADER VALUE -->
      <mat-form-field appearance="outline">
        <input matInput class="text-field-padding"
               [type]="settingsForm.get('header_secret_' + header.id)?.value  ? 'password' : 'text'"
               placeholder="Bearer token..."
               formControlName="header_value_{{header.id}}"
               name="header_value_{{header.id}}" />
      </mat-form-field>

      <!-- SECRET BUTTON -->
      <button type="button"
              mat-icon-button
              class="secret-button"
              [color]="settingsForm.get('header_secret_' + header.id)?.value ? 'primary' : undefined"
              (click)="toggleHeaderSecret(header.id)"
              [matTooltip]="settingsForm.get('header_secret_' + header.id)?.value ? 'Show value' : 'Hide value'">
        <mat-icon>
          {{
settingsForm.get('header_secret_' + header.id)?.value
  ? 'visibility_off'
  : 'visibility'
          }}
        </mat-icon>
      </button>

      <!-- REMOVE BUTTON -->
      <button type="button"
              mat-icon-button
              color="warn"
              class="remove-button"
              (click)="removeHeader(i)">

        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <button type="button"
            mat-stroked-button
            color="primary"
            (click)="addHeader()">

      <mat-icon>add</mat-icon>
      Add Header
    </button>
  </mat-card>

  <!-- QUERY PARAMETERS -->
  <mat-card class="config-section">
    <mat-card-title>Query Parameters</mat-card-title>
    <div class="table-header-3-cols">
      <div>Parameter</div>
      <div>Value</div>
      <div></div>
    </div>

    <div class="table-row-3-cols"
         *ngFor="let param of settings.parameters; let i = index">

      <!-- PARAMETER NAME -->
      <mat-form-field appearance="outline">
        <input matInput class="text-field-padding"
               placeholder="page"
               formControlName="param_key_{{param.id}}"
               name="param_key_{{param.id}}" />
      </mat-form-field>

      <!-- PARAMETER VALUE -->
      <mat-form-field appearance="outline">
        <input matInput class="text-field-padding"
               [type]="text"
               placeholder="1"
               formControlName="param_value_{{param.id}}"
               name="param_value_{{param.id}}" />
      </mat-form-field>

      <!-- REMOVE BUTTON -->
      <button type="button"
              mat-icon-button
              color="warn"
              class="remove-button"
              (click)="removeParameter(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <button type="button"
            mat-stroked-button
            color="primary"
            (click)="addParameter()">
      <mat-icon>add</mat-icon>
      Add Parameter
    </button>
  </mat-card>
</div>

<div class="test-row">
  <button type="button"
          mat-raised-button
          color="primary"
          [disabled]="isTesting"
          (click)="testRequest()">
    {{ isTesting ? 'Testing...' : 'Test' }}
  </button>
</div>

<mat-card *ngIf="testResult" class="test-result-card">
  <mat-card-title>Test Result</mat-card-title>
  <div [class]="testResult.success ? 'test-ok' : 'test-error'">Status: {{ testResult.reasonPhrase }}</div>
  <pre>{{ testResult.content}}</pre>
</mat-card>
</div>
